import { render, staticRenderFns } from "./FormReferenceValue.vue?vue&type=template&id=078e6fd7&"
import script from "./FormReferenceValue.vue?vue&type=script&lang=js&"
export * from "./FormReferenceValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports